export default __webpack_public_path__ + "static/media/ev-mobile.b9926c8a.jpg";